<div
  class="w-full h-[15rem] before:content-[''] before:w-full before:h-full before:block before:bg-gradient-to-b before:from-p-100 before:to-transparent fixed top-0 left-0 before:-translate-y-[5rem]{{
    classes
  }}"
  role="presentation"
></div>
